import React from "react";
import { useDispatch, useSelector } from "react-redux";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import Langs from "../../../app/lang/langs";
import ConfirmDialog from "../../../components/popups/ConfirmDialog";
import { showErrorToast, checkPermission } from "../../../app/utils/helpers";
import { config } from "../../../app/utils/config";
import { prefillPlanning, getPlanning } from "../planningSlice";

export function MobilePrefillModal({ show, onHide }) {
  const dispatch = useDispatch();

  const selectedTeamsIds = useSelector((state) => state.teams.selectedTeamsIds);
  const selectedDate = useSelector((state) => state.planning.selectedDate);
  const collabs = useSelector((state) => state.collabs.list);

  function isManager(teamId) {
    return checkPermission(config.scopes.shifts, config.permissionTypes.edit, teamId);
  }

  function handlePrefill() {
    if (!isManager(selectedTeamsIds[0])) return;
    dispatch(
      prefillPlanning({
        id_team: selectedTeamsIds[0],
        month: new Date(selectedDate).getMonth(),
        year: new Date(selectedDate).getFullYear(),
      })
    ).then((response) => {
      if (response["payload"]["responseData"]["status"] == 1) {
        loadPlanning();
      }
      if (response["payload"]["responseData"]["status"] == 4) {
        showErrorToast(response["payload"]["responseData"]["message"]);
      }
      if (response["payload"]["responseError"]) {
        showErrorToast();
      }
    });
    onHide();
  }

  function loadPlanning() {
    if (selectedTeamsIds && selectedTeamsIds.length && collabs.length) {
      let selectedCollabsIds = collabs.reduce((array, current) => {
        array.push(current.id);
        return array;
      }, []);
      dispatch(getPlanning({ selectedTeamsIds, selectedCollabsIds }));
    }
  }

  return (
    <ConfirmDialog
      open={!!show}
      icon={AutoFixHighIcon}
      title={<Langs str="PREFILL" />}
      message={<Langs str="ARE_YOU_SURE_PREFILL" />}
      confirmLabel={<Langs str="YES" />}
      onConfirm={handlePrefill}
      onCancel={onHide}
    />
  );
}
